export type ShippingInstructionsTimeOnTaskEventArgs = {
  screen: string
  duration: number
  shipmentId: number | undefined
}

export type ShippingInstructionsTimeOnTaskEventExtra = {
  screen: string
  duration: number
  shipment_id: number | undefined
}

export const shippingInstructionsTimeOnTaskEvent = (
  args: ShippingInstructionsTimeOnTaskEventArgs,
) => {
  const extra: ShippingInstructionsTimeOnTaskEventExtra = {
    screen: args.screen,
    duration: args.duration,
    shipment_id: args.shipmentId,
  }

  return {
    event: 'shipping_instructions.time_in_shipping_instructions',
    extra,
  }
}
